/**
 * 사용자 문서의 `lastWorkspace` 값을 워크스페이스 id 문자열로 닫는다 — 없거나 거짓 값이면 `''`, 앞뒤 공백은 자른다.
 *
 * 값을 받는다(사용자 객체가 아니라) — 훅 의존성이 `user?.lastWorkspace` 한 칸으로 남게 하려는 것이다.
 *
 * ⚠️ `||` 판본이다 — `0`·`false`·`NaN` 도 `''` 가 된다. `?? ''` 로 쓰는 자리(`0` → `'0'`)와는 결과가
 * 달라 이것으로 바꾸지 않는다.
 *
 * @param lastWorkspace `user?.lastWorkspace`
 */
export function toLastWorkspaceId(lastWorkspace: unknown): string {
  return String(lastWorkspace || '').trim();
}

/**
 * 지금 워크스페이스의 id — 고른 워크스페이스의 `id` → `workspaceId` → 사용자 `lastWorkspace` 차례로 첫 참값을 문자열로, 앞뒤 공백을 자른다.
 *
 * @param currentWorkspace `findCurrentWorkspace(user)`
 * @param lastWorkspace `user?.lastWorkspace`
 */
export function toCurrentWorkspaceId(
  currentWorkspace: Record<string, any> | null | undefined,
  lastWorkspace: unknown
): string {
  return String(currentWorkspace?.id || currentWorkspace?.workspaceId || lastWorkspace || '').trim();
}
